import { tv } from 'tailwind-variants'

export const paperVariants = tv({
  variants: {
    variant: {
      elevation: '',
      outlined: 'border border-divider',
    },
    elevation: {
      '0': 'bg-paper-elevation0',
      '1': 'bg-paper-elevation1',
      '2': 'bg-paper-elevation2',
      '3': 'bg-paper-elevation3',
      '4': 'bg-paper-elevation4',
      '5': 'bg-paper-elevation5',
      '6': 'bg-paper-elevation6',
      '7': 'bg-paper-elevation7',
      '8': 'bg-paper-elevation8',
      '9': 'bg-paper-elevation9',
      '10': 'bg-paper-elevation10',
      '11': 'bg-paper-elevation11',
      '12': 'bg-paper-elevation12',
      '13': 'bg-paper-elevation13',
      '14': 'bg-paper-elevation14',
      '15': 'bg-paper-elevation15',
      '16': 'bg-paper-elevation16',
      '17': 'bg-paper-elevation17',
      '18': 'bg-paper-elevation18',
      '19': 'bg-paper-elevation19',
      '20': 'bg-paper-elevation20',
      '21': 'bg-paper-elevation21',
      '22': 'bg-paper-elevation22',
      '23': 'bg-paper-elevation23',
      '24': 'bg-paper-elevation24',
    },
    square: {
      true: '',
      false: 'rounded-sm',
    },
  },
  compoundVariants: [
    // outlined always renders on the flat surface, regardless of the elevation prop
    { variant: 'outlined', className: 'bg-paper-elevation0' },
  ],
  defaultVariants: {
    variant: 'elevation',
    elevation: '1',
    square: false,
  },
})
